import { CSSProperties, ReactNode } from "react";
import styled from "@emotion/styled";

import UIcon, { IconKey } from "../../lib/icons/untitled_ui/UIcon";
import { Flex } from "../../styles/utility-components";

type Props = {
  title?: ReactNode;
  icon?: IconKey;
  iconProps?: { color?: string; fill?: boolean };
  styles?: CSSProperties;
};

export default function EntityTag({ title, icon, iconProps, styles }: Props) {
  return (
    <Container styles={styles}>
      {icon && (
        <UIcon
          icon={icon}
          color={iconProps?.color ?? "sysPrimaryPressed"}
          fill={iconProps?.fill ? "currentColor" : "none"}
          size={12}
        />
      )}
      <TextContainer fontColor={styles?.color}>
        <EllipsisText>{title}</EllipsisText>
      </TextContainer>
    </Container>
  );
}

const Container = styled(Flex)<{
  styles?: CSSProperties;
}>(({ theme, styles }) => ({
  display: "flex",
  backgroundColor: styles?.backgroundColor ?? theme.colors.sysPrimarySubtle,
  height: "24px",
  padding: "0px 10px 0px 8px",
  justifyContent: "center",
  alignItems: "center",
  gap: "6px",
  border: `1px solid ${styles?.borderColor}`,
  borderRadius: "3px",
  width: "fit-content",
  minWidth: 0,
  flexShrink: styles?.flexShrink,
}));

const TextContainer = styled(Flex)<{ fontColor?: string }>(({ theme, fontColor }) => ({
  color: fontColor ?? theme.colors.sysPrimaryPressed,
  fontWeight: "500",
  fontSize: "12px",
  overflow: "hidden",
}));

const EllipsisText = styled.span({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});
